import { object, number, string, boolean, enum as enum_ } from 'zod';

export const schemaGeneralData = object({
  professional: number().nonnegative({
    message: 'Profissional inválido ou não encontrado.',
  }),
  appointment: number().nonnegative().optional(),
  org: number().nonnegative({ message: 'Instituição Inválida' }).optional(),
  orgUnit: number().nonnegative().optional(),
  healthUnit: number().optional(),
  specialty: number().optional(),
  // specialty: number().nonnegative({
  //   message: 'Especialidade inválida ou não encontrado.',
  // }),
  state: string().optional(),
  // state: string().nonempty({ message: 'Campo obrigatório' }),
  county: string().optional(),
  // .nonempty({ message: 'Campo obrigatório' })
  // .refine(value => !value.includes('Selecione'), {
  //   message: 'Selecione seu município',
  // }),
});

export const schemaGeneralDataApac = object({
  professional: number().nonnegative({
    message: 'Profissional inválido ou não encontrado.',
  }),
  appointment: number().nonnegative().optional(),
  org: number().nonnegative({ message: 'Instituição Inválida' }).optional(),
  orgUnit: number().nonnegative().optional(),
  healthUnit: number().nonnegative({ message: 'Unidade de saúde obrigatória' }),
  specialty: number().optional(),
  // specialty: number().nonnegative({
  //   message: 'Especialidade inválida ou não encontrado.',
  // }),
  state: string().optional(),
  // state: string().nonempty({ message: 'Campo obrigatório' }),
  county: string().optional(),
  // .nonempty({ message: 'Campo obrigatório' })
  // .refine(value => !value.includes('Selecione'), {
  //   message: 'Selecione seu município',
  // }),
});

export const schemaPatientData = object({
  situation: string().nonempty(),
  birthDate: string()
    .nonempty({ message: 'Insira a data de nascimento' })
    .optional(),
  patient: object({
    fullname: string().optional(),
    gender: string().optional(),
    age: number().optional(),
    id: number().nonnegative({ message: 'Selecione um paciente' }).optional(),
    birthDate: string().optional(),
    medicalRecord: string().optional(),
    phone: string().optional(),
    email: string().optional(),
    motherName: string().optional(),
  }),
})
  .refine(
    data => {
      if (!data.patient.id && data.situation === 'REGISTERED') {
        return false;
      }

      return true;
    },
    { message: 'Paciente inválido ou não encontrado.', path: ['patient.id'] },
  )
  .refine(
    data => {
      if (
        !data.birthDate &&
        // typeof data.patient.age === 'number' &&
        data.situation === 'NOT-REGISTERED'
      ) {
        return false;
      }
      return true;
    },
    { message: 'Preencha os campos obrigatórios.', path: ['birthDate'] },
  )
  .refine(
    data => {
      if (!data.patient.fullname && data.situation === 'NOT-REGISTERED') {
        return false;
      }
      return true;
    },
    { message: 'Preencha os campos obrigatórios.', path: ['patient.fullname'] },
  );

export const schema = object({
  appointment: number().nonnegative().optional(),
  org: number().nonnegative().optional(),
  orgUnit: number().nonnegative().optional(),
  professional: number().nonnegative().optional(),
  specialty: number().nonnegative().optional(),
  patient: number().nonnegative().optional(),
  type: number().nonnegative(),
  certificate: string().optional(),
  certificateId: string().optional(),
  sidebar: boolean().optional(),
  content: object({}).nonstrict().optional(),
  signatureSource: string().optional(),
}).refine(data => {
  // if ((!data.appointment && (!data.professional || !data.specialty || !data.org || !data.orgUnit))) return false;
  if (!data.appointment && (!data.professional || !data.org || !data.orgUnit))
    return false; // avulso
  if (
    data.appointment &&
    (data.professional || data.specialty || data.org || data.orgUnit)
  )
    return false; // vinculado
  return true;
});
